/*!

=========================================================
* Paper Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Pics from "views/Pics.jsx";
import House from "views/House.jsx";
import Health from "views/Health.jsx";
import Maps from "views/Map.jsx";
import Blog from "views/Blog.jsx";
import Solar from "views/Solar.jsx";
/*
import Blog from 'views/Blog'
import BlogPost from 'views/BlogPost'
import Control from "views/Control.jsx";
*/
import Webcam from "views/Webcam.jsx";
import Thermostat from "views/Thermostat.jsx";
import Devices from "views/Devices.jsx";
import Reports from "views/Reports.jsx";
import Downloads from "views/Downloads.jsx";
import BatteryWatch from "views/BatteryWatch.jsx";
import WiFi from "views/WiFi.jsx";


var routes = [
  {
    path: "/pics",
    name: "Pics",
    icon: "nc-icon nc-bank",
    component: Pics,
    layout: ""
  },
  {
    path: "/house",
    name: "House",
    icon: "nc-icon nc-bank",
    component: House,
    layout: ""
  },
  {
    path: "/thermostat",
    name: "Thermostat",
    icon: "nc-icon nc-button-power",
    component: Thermostat,
    layout: ""
  },
  {
    path: "/health",
    name: "Health",
    icon: "nc-icon nc-bank",
    component: Health,
    layout: ""
  },
  {
    path: "/maps",
    name: "Maps",
    icon: "nc-icon nc-pin-3",
    component: Maps,
    layout: ""
  },
  {
    path: "/batterywatch",
    name: "BatteryWatch",
    icon: "nc-icon nc-bell-55",
    component: BatteryWatch,
    layout: ""
  },
  {
    path: "/wifi",
    name: "WiFi",
    icon: "nc-icon nc-bell-55",
    component: WiFi,
    layout: ""
  },
  {
    path: "/webcam",
    name: "Birds!",
    icon: "nc-icon nc-button-play",
    component: Webcam,
    layout: ""
  },
  {
    path: "/downloads",
    name: "Downloads",
    icon: "nc-icon nc-diamond",
    component: Downloads,
    layout: ""
  },
  {
    path: "/devices",
    name: "Devices",
    icon: "nc-icon nc-diamond",
    component: Devices,
    layout: ""
  },
  {
    path: "/reports",
    name: "Reports",
    icon: "nc-icon nc-diamond",
    component: Reports,
    layout: ""
  },
  {
    path: "/solar",
    name: "Solar",
    icon: "nc-icon nc-bell-55",
	exact: true,
    component: Solar,
    layout: ""
  },
  {
    path: "/blog",
    name: "Blog",
    icon: "nc-icon nc-pin-3",
	exact: true,
    component: Blog,
    layout: ""
  },
/*
  {
    path: "/control",
    name: "Control",
    icon: "nc-icon nc-button-power",
    component: Control,
    layout: ""
  },
  {
	path: "/blog/:page",
    name: "Blog",
    icon: "nc-icon nc-pin-3",
	exact: true,
    component: Blog,
    layout: ""
  },
  {
    path: "/blog/posts/:post",
    name: "Blog Post",
    icon: "nc-icon nc-pin-3",
    component: BlogPost,
    layout: ""
  },
*/
];

export default routes;
